import { createFileRoute } from '@tanstack/react-router'
import { noop } from '@tanstack/react-query'
import { trpc } from '@/main'

// Pathless layout that OWNS the filter-keyed list, so a filter re-keys THIS match and not the page with its filter bar.
export const Route = createFileRoute('/_app/admin/sessions/_list')({
  loaderDeps: ({ search }) => ({ since: search.since, errors: search.errors, q: search.q }),
  context: ({ deps }) => ({
    sessionsInfiniteQueryOptions: trpc.admin.listSessions.infiniteQueryOptions(
      { since: deps.since, errorsOnly: deps.errors || undefined, search: deps.q.trim() || undefined },
      { getNextPageParam: (page) => (page.ok ? page.nextCursor : undefined) },
    ),
  }),
  loader: ({ context }) => {
    context.queryClient.infiniteQuery(context.sessionsInfiniteQueryOptions).catch(noop)
  },
})
